import { IUser } from '@/constants';
import { FacilityFieldsFragment } from '@/graphql/__generated/sdk';
import { Maybe } from '@/types';

export async function getPosition({
	officeInfo,
	defaultToCdn = false,
	user,
}: {
	defaultToCdn?: boolean;
	user?: Maybe<IUser>;
	officeInfo?: FacilityFieldsFragment | null;
}) {
	if (officeInfo?.location) {
		return {
			latitude: officeInfo?.location?.latitude as number,
			longitude: officeInfo?.location?.longitude as number,
		};
	}

	if (defaultToCdn) {
		return {
			latitude: (user?.coordinates?.latitude as number) || 0,
			longitude: (user?.coordinates?.longitude as number) || 0,
		};
	}

	if (typeof globalThis.window === 'undefined') {
		return { latitude: 0, longitude: 0 };
	}

	const fallbackCoords =
		user?.hasIpBasedCoordinates && user?.coordinates ? user.coordinates : { latitude: 0, longitude: 0 };
	return getBrowserPosition(fallbackCoords);
}

export const getUsersPosition = (): Promise<GeolocationPosition> => {
	return new Promise((resolve, reject) => {
		globalThis.navigator?.geolocation.getCurrentPosition(resolve, reject);
	});
};

export async function getBrowserPosition(fallbackCoords: { latitude: number; longitude: number }) {
	if (!globalThis?.navigator?.geolocation) {
		return fallbackCoords;
	}
	try {
		const position = await getUsersPosition();
		return position.coords;
	} catch (error) {
		console.error('Failed to get geolocation position:', error);
		return fallbackCoords;
	}
}
